import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Result,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import { route } from "./routes/routes";
import { AuthWrapper, useAuth } from "./utils/Auth/AuthWrapper";
import ProtectedRoute from "./utils/Auth/ProtectedRoute";
import DefaultLayout from "./layout/defualtLayout";
import LoginPage from "./views/login";
import LandingPage from "./layout/LandingPage";
import ForgotPass from "./views/forgotPass";
import RegisterPage from "./views/registerPage";
import ConfirmPage from "./views/confirm";
import ConfirmForgot from "./views/confirmforgot";
import Main from "./views/main";
import NotFoundPage from "./views/notFound";

function App() {
  const auth = useAuth();

  let user = JSON.parse(localStorage.getItem("stt"));
  if (user == null || user === undefined || user == "") {
    user = {
      accessToken:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE4MTkwMjU5MjN9.3Ba7mKxxjsBcp_aOmaP7P16E25_gZLSNwtjNkWATWNY",
      user_status: 1,
      user_id: null,
      user_name: null,
      profile_img: null,
      org_id: "e82fb7f3-3fa0-446d-8ef4-9743421b4ca8",
      org_name: "Ai9",
      role: "User",
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE4MTkwMjU5MjN9.3Ba7mKxxjsBcp_aOmaP7P16E25_gZLSNwtjNkWATWNY",
      expiresIn: null,
    };
    localStorage.setItem("stt", JSON.stringify(user));
  }

  localStorage.setItem("confooterSection", "sectioncontact");

  return (
    <Router basename={"/"}>
      <AuthWrapper>
        <Routes>
          {/* <Route
            path="/"
            // element={<Navigate to="/dashboard" replace={true} />}
            // element={<LandingPage />}
            element={<Main />}
            // element={<DefaultLayout />}
          /> */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/500" element={<>500</>} />
          {/* <Route path="/user/forgot/reset" element={<ForgotPass />} /> */}
          <Route path="/user/register/new" element={<RegisterPage />} />
          <Route path="/user/register/confirm/:id" element={<ConfirmPage />} />
          {/* <Route path="/user/forgot/reset/:id" element={<ConfirmForgot />} /> */}
          {/* <Route path="/user/confirmpassword/:token" element={<ConfirmForgot />} /> */}
          <Route element={<DefaultLayout />}>
            {route.map((routes, ind) => {
              if (routes.routes) {
                return (
                  <Route key={`route-${ind}`} path={routes.path}>
                    {routes.routes.map((child, inds) => {
                      return (
                        <Route
                          key={`child-${inds}`}
                          path={child.path}
                          element={
                            <ProtectedRoute access={routes.access}>
                              {child.component}
                            </ProtectedRoute>
                          }
                        />
                      );
                    })}
                  </Route>
                );
              } else {
                return (
                  <Route
                    key={`route-${ind}`}
                    path={routes.path}
                    element={
                      <ProtectedRoute access={routes.access}>
                        {routes.component}
                      </ProtectedRoute>
                    }
                  />
                );
              }
            })}
          </Route>
          <Route path="*" element={<Navigate to="/404" replace={true} />} />
        </Routes>
      </AuthWrapper>
    </Router>
  );
}

export default App;
